export default "__VITE_ASSET__fyYjNtJo__"